<template lang="pug">
.k-layout-page-title(:class="sizeClasses")
  .text-xs-center
    h1.font-family--secondary
      slot
</template>

<script>
import { Sizeable } from '@/mixins'

export default {
  mixins: [
    Sizeable,
  ]
}
</script>

<style lang="scss" scoped>
.k-layout-page-title {
  padding: 45px 0;

  @include sm-and-down {
    padding: 25px 0;
  }

  h1 {
    font-size: 45px;
    letter-spacing: -1px;
    line-height: 73px;

    @include sm-and-down {
      font-size: 27px;
      line-height: 33px;
    }
  }

  // only used on the booking page for now
  &--large {
    padding: 76px 0 65px;

    @include sm-and-down {
      padding: 39px 0 36px;
    }

    h1 {
      font-size: 36px;
      letter-spacing: -.5px;
      line-height: 73px;

      @include sm-and-down {
        font-size: 21px;
        line-height: 33px;
      }
    }
  }
}
</style>
